export default __webpack_public_path__ + "static/media/ascend-white.751a71a4.svg";